/* eslint-disable react/jsx-key */
/* eslint-disable max-len */
/* eslint-disable security/detect-object-injection */
/* eslint-disable security/detect-unsafe-regex */

import React, { useState } from 'react'
import LedgerSearch from './LedgerSearch';
import InvoiceReferenceDropdown from './VoucherPayment/InvoiceReferenceDropdown';
import { GetBranchId } from '../../../../CommonMethods/GetBranchId'
import { dataService } from '../../../../services/data.services'
import moment from 'moment'

export default function Account({
    AccountType,
    AccountOption,
    multiField,
    setMultiField,
    newMultiField,
    singleAccount, 
    setSingleAccount,
    setSingleAccountId,
    setWarningMessage,
    singleAccountNumber, 
    setSingleAccountNumber,
    accountNameError, 
    setAccountNameError,
    amountError, 
    setAmountError,
    setToastErrorMessage,
    LegerEndpoint,
    singleAccountId,
    classKey,
    submitSelected,
    setsubmitSelected,
    selectedAmountIndex, 
    setSelectedAmountIndex,
    setSchemeStudentsData,
    handleSchemeLedger,
    setSchemeLedgerId,
    searchParams,
    setSearchParams
}) {

    /**
     * The `handleAddField` function adds a new field to a list of fields, with error handling and a
     * maximum limit check.
     */
    const handleAddField = () => {
        if(setSelectedAmountIndex) {
            setSelectedAmountIndex(null);
        }
        setAccountNameError(false)
        setAmountError(false)
        setToastErrorMessage('')
        if(setsubmitSelected) {
            setsubmitSelected(false)
        }
        const updatedFields = [
            ...multiField,
            newMultiField,
        ];
        setMultiField(updatedFields);
        if (multiField?.length === 19)  {
            setWarningMessage(`Maximum of 20 ${AccountType} Accounts can be added at a time.`)
        }
    };

    /**
     * The function `handleRemoveField` removes a field from a list of fields based on the index
     * provided.
     */
    const handleRemoveField = (indexToRemove) => {
        if(setSelectedAmountIndex) {
            setSelectedAmountIndex(null);
        }        setAccountNameError(false)
        if(setsubmitSelected) {
            setsubmitSelected(false)
        }
        setAmountError(false)
        setToastErrorMessage('')
        const updatedFields = multiField.filter((_, index) => index !== indexToRemove);
        setMultiField(updatedFields);
    };

    /**
     * The function `handleSearchFiled` updates fields based on the selected account option, either
     * setting single account details or updating multiple fields with account information.
     */
    const handleSearchFiled = (index, items, key) => {
        if(setSelectedAmountIndex) {
            setSelectedAmountIndex(null);
        }
        if (AccountOption === "single") {
            setSingleAccount(items.parent_group_name_composite_key);
            setSingleAccountId(items._id);
        } else {
            const updatedFields = [...multiField];
            if(key === "invoice_reference_number") {
                updatedFields[index] = {
                    ...updatedFields[index],
                    invoice_reference_number: items.reference_number,
                    invoice_date: items.date,
                    invoice_reference_number_id : items._id,
                    account_number : items.pending_amount,
                    actual_pending_amount : items.pending_amount
                };
            } else {
                updatedFields[index] = {
                    ...updatedFields[index],
                    account_id: items._id,
                    account_name: items.parent_group_name_composite_key
                };
            }
            
            setMultiField(updatedFields);
        }
    };
    
    /**
     * The handleFieldChange function in JavaScript React sets a new account number value in a
     * multiField array based on certain conditions.
     */
    const handleFieldChange = (index, value) => {
        if(setSelectedAmountIndex) {
            setSelectedAmountIndex(null);
        }
        setToastErrorMessage('');
        setAmountError(false);
        if (value.length <= 13) {
            const regex = /^(\d{1,10}(\.\d{0,2})?)?$/;
            if (regex.test(value)) {
                const updatedFields = [...multiField];
                if(LegerEndpoint === "payment") {
                    if(updatedFields[index].invoice_reference_number !== undefined && value !== "") {
                        if(Math.round(parseFloat(updatedFields[index].actual_pending_amount) * 100) < Math.round(parseFloat(value) * 100)) {
                            setSelectedAmountIndex(index)
                            setToastErrorMessage(`${updatedFields[index].invoice_reference_number}: Payment amount cannot be more than the payable's pending amount of ${parseFloat(updatedFields[index].actual_pending_amount).toFixed(2)}`)
                            updatedFields[index] = {...updatedFields[index], account_number: value};
                        } else {
                            updatedFields[index] = {...updatedFields[index], account_number: value};
                        }
                    } else {
                        updatedFields[index] = {...updatedFields[index], account_number: value};
                    }
                } else {
                    updatedFields[index] = {...updatedFields[index], account_number: value};
                }
                setMultiField(updatedFields);
            }
        }
    };
    
    /**
     * The handleCheckBox function toggles the is_payable property of an item in a multiField array in
     * React.
     */
    const handleCheckBox = (index) => {
        const updatedFields = [...multiField];
        updatedFields[index] = {
            ...updatedFields[index],
            is_payable: !updatedFields[index].is_payable
        };
        setMultiField(updatedFields);
    };
    
    const clearIfValueIsZero = (index) => (e) => {
        
        if (Number(e.target.value) === 0) {
            index === undefined ? handleInputChange(e, ''): handleFieldChange(index, '');
        }
    };

    const setZeroIfEmpty = (index) => (e) => {
        let value = e.target.value;
        if (value === '') {
            value = '0.00';
        } else {
            value = parseFloat(value).toFixed(2);
        }

        index === undefined ? handleInputChange(e, value): handleFieldChange(index, value);
    };

    /**
     * The function `handleInputChange` validates and sets a single account number based on user input
     * within certain length and format constraints.
     */
    const handleInputChange = (e, value) => {
        if(setSelectedAmountIndex) {
            setSelectedAmountIndex(null);
        }
        setAmountError(false);
        setToastErrorMessage("")
        value = (value === undefined ? e.target.value : value)
        if(e.target.value.length <= 13) {
            const regex = /^(\d{1,10}(\.\d{0,2})?)?$/;
            if(regex.test(e.target.value)) {
                setSingleAccountNumber(value);
            }
        }
    }

    /**
     * The function `getAmount` calculates the total sum of valid account numbers in the `multiField`
     * array.
     * @returns The `getAmount` function is returning the total sum of all valid account numbers in the
     * `multiField` array. It iterates over each item in the `multiField` array, checks if the
     * `account_number` property is a valid number using `isNaN` and `parseFloat`, and if it is valid,
     * adds it to the `total`. Finally, it returns the calculated `total`
     */
    const getAmount = () => {
        let total = 0.00;

        multiField.map((item) => {
            if(!isNaN(parseFloat(item.account_number))) {
                total += parseFloat(item.account_number)
            }
        })
        return total;
    }


    const handleSchemeLedgerValidation = async (index, items, key) => {
        if (AccountType === "Source" && LegerEndpoint === "RTE-Scholarship" && items.is_scheme_ledger) {
            setSchemeLedgerId(items._id);
            handleSchemeLedger();
        }
    }

    return (
        <div className={`border border-[#E6E8EA] h-fit z-0 ${AccountType === "Destination" ? "ml-[18px]" : ""} ${classKey !== undefined ? classKey : AccountOption === "multi" ? "w-[480px]" : "w-[410px] h-[166px]"}`}>
            <div className='flex w-full'>
                <div className='w-full'>
                    <div className='flex p-2 font-semibold text-f7 text-[#031624] border-b border-[#E6E8EA] w-full formHeaderbg' >
                        {(AccountType === "Source" && LegerEndpoint === "journal" )&& <h1 className='w-[85px]' >Is Payable</h1>} 
                        <h1 className={`${LegerEndpoint === "journal" ? "w-[210px]" : LegerEndpoint === "payment" ? "w-[200px]" : "w-[240px]"}`} >{AccountType} Account ({AccountType == "Source" ? "Cr": "Dr"})</h1> 
                        {(AccountType === "Destination" && LegerEndpoint === "payment") && <h1 className='w-[200px] pl-5'>Invoice Reference #</h1>}
                        <h1 className={`justify-end flex  ${LegerEndpoint === "payment" || LegerEndpoint === "journal" ? "w-[130px]" : "w-[155px] "}`}>Amount</h1> 
                    </div>
                    {AccountOption === "single" ?
                        <div className='flex p-2 py-[10px] border-b border-[#E6E8EA]'>
                            
                            <div class={`relative`}>
                                <LedgerSearch 
                                    handleSearchFiled={handleSearchFiled}
                                    multiField={multiField}
                                    setMultiField={setMultiField}
                                    newMultiField={newMultiField}
                                    AccountOption={AccountOption}
                                    singleAccount={singleAccount}
                                    setSingleAccount={setSingleAccount}
                                    accountNameError={accountNameError}
                                    setAccountNameError={setAccountNameError}
                                    setToastErrorMessage={setToastErrorMessage}
                                    LegerEndpoint={LegerEndpoint}
                                    setSingleAccountId={setSingleAccountId}
                                    singleAccountId={singleAccountId}
                                    AccountType={AccountType}
                                    setSelectedAmountIndex={setSelectedAmountIndex}
                                    handleSchemeLedgerValidation={handleSchemeLedgerValidation}
                                    setSchemeStudentsData={setSchemeStudentsData}
                                    setSchemeLedgerId={setSchemeLedgerId}
                                    searchParams={searchParams}
                                    setSearchParams={setSearchParams}
                                />
                            </div>  
                            <div className={`pl-[20px] ${LegerEndpoint === "payment" ? "w-[130px]" : "w-[155px]"}`}>
                                <input 
                                    type="text" 
                                    autocomplete="off" 
                                    id={`${AccountType}_amount`}
                                    maxlength="13" 
                                    className={`inpt-fld text-end ${(amountError && (singleAccountNumber === "0.00" || isNaN(parseFloat(singleAccountNumber)) || parseFloat(singleAccountNumber) === 0)) ? "redBorder" : ""}  w-full error_border`} 
                                    placeholder="0.00" 
                                    isAmountField = {true}
                                    value={singleAccountNumber}
                                    onChange={(e) => handleInputChange(e)}
                                    onFocus={clearIfValueIsZero(undefined)}
                                    onBlur={setZeroIfEmpty(undefined)}
                                />
                            </div> 
                        </div>
                        :
                        <div className={multiField.length > 6 ? `` : ""}> 
                            {/* max-h-[calc(100vh-387px)] overflow-auto overflow-x-hidden scroll-bar z-10  */}
                            {multiField.map((field, index = 0) => (
                                <div className={`flex p-2 py-[10px] border-b border-[#E6E8EA]`}>
                                    <div className={` flex  `}>
                                        {(AccountType === "Source" && LegerEndpoint === "journal" ) && 
                                        <div className='w-[85px] relative '>
                                            <div class="checkbox custom-checkBoxBlue1 ispayable relative">
                                                <input 
                                                    type="checkbox" 
                                                    id={`${index}invoice`} 
                                                    data-testid="text-box" 
                                                    name={`${index}invoice`}
                                                    checked={field.is_payable}
                                                    onChange={(e) => handleCheckBox(index)}
                                                />
                                                <label 
                                                    for={`${index}invoice`} 
                                                    className="text-f2 font-semibold text-[#031624] pl-[22px] w-full cursor-pointer "
                                                ></label>
                                            </div>
                                        </div>
                                        }
                                        <LedgerSearch 
                                            index={index}
                                            handleSearchFiled={handleSearchFiled}
                                            multiField={multiField}
                                            setMultiField={setMultiField}
                                            newMultiField={newMultiField}
                                            AccountOption={AccountOption}
                                            accountNameError={accountNameError}
                                            setAccountNameError={setAccountNameError}
                                            setToastErrorMessage={setToastErrorMessage}
                                            LegerEndpoint={LegerEndpoint}
                                            singleAccount={singleAccount}
                                            AccountType={AccountType}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            setSelectedAmountIndex={setSelectedAmountIndex}
                                        />
                                        {LegerEndpoint === "payment" && 
                                        <InvoiceReferenceDropdown
                                            index={index}
                                            handleSearchFiled={handleSearchFiled}
                                            multiField={multiField}
                                            setMultiField={setMultiField}
                                            newMultiField={newMultiField}
                                            AccountOption={AccountOption}
                                            accountNameError={accountNameError}
                                            setAccountNameError={setAccountNameError}
                                            setToastErrorMessage={setToastErrorMessage}
                                            LegerEndpoint={LegerEndpoint}
                                            singleAccount={singleAccount}
                                            AccountType={AccountType}
                                            submitSelected={submitSelected}
                                            setsubmitSelected={setsubmitSelected}
                                            invoiceReference={multiField[index]}
                                            buttonDisabled={multiField[index].account_id === ""}
                                            account_id={multiField[index].account_id}
                                        />
                                        }
                                        <div class={`${LegerEndpoint === "journal" ? "w-[130px]" : LegerEndpoint === "payment" ? "w-[130px]" : "w-[155px]"} pl-[20px]`}>
                                            <input 
                                                type="text" 
                                                autocomplete="off" 
                                                id={`${AccountType}_amount`}
                                                maxlength="13" 
                                                className={`inpt-fld text-end ${((amountError && (field.account_number === "0.00" || isNaN(parseFloat(field.account_number)) || parseFloat(field.account_number) === 0)) || selectedAmountIndex === index) ? "redBorder" : ""} w-full error_border`} 
                                                placeholder="0.00" 
                                                isAmountField = {true}
                                                disabled="" 
                                                value={field.account_number}
                                                onChange={(e) => {handleFieldChange(index, e.target.value)}}
                                                onFocus={clearIfValueIsZero(index)}
                                                onBlur={setZeroIfEmpty(index)}
                                            />
                                        </div> 
                                    </div>
                                    <div className="flex items-center">
                                        {index === multiField?.length - 1 ? (
                                            <>
                                                {index !== 0 && <div className='group relative'>
                                                    <img
                                                        src="/images/delete-bg-red-icon.svg"
                                                        alt="icon"
                                                        className="ml-2 cursor-pointer delete-icon"
                                                        onClick={() => handleRemoveField(index)}
                                                    />
                                                    <span class="absolute top-8 -left-[3px] scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Delete</span>
                                                </div>}
                                                {index !== 19 &&<div className='group relative'>
                                                    <img
                                                        src="/images/add-icon-blue.svg"
                                                        id = "plus_iconn"
                                                        alt="icon"
                                                        className="ml-2 cursor-pointer add-icon"
                                                        onClick={handleAddField} 
                                                    />
                                                    <span class="absolute top-8 left-[5px] scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Add</span>
                                                </div>}
                                                    
                                            </>
                                        ) : (
                                            <div className='group relative'>
                                                <img
                                                    src="/images/delete-bg-red-icon.svg"
                                                    alt="icon"
                                                    className="ml-2 cursor-pointer delete-icon"
                                                    onClick={() => handleRemoveField(index)}
                                                />
                                                <span class="absolute top-8 -left-[3px] scale-0 inline-flex flex-shrink-0 justify-center items-center gap-2.5 p-2.5 h-5 rounded-sm bg-[#d0d5dd] text-[#344054] text-xs font-medium leading-[12.5px] group-hover:scale-100">Delete</span>

                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    }
                    
                                      
                </div>
                   
            </div>

            <div className={`flex items-center my-2`} style={LegerEndpoint === "RTE-Scholarship"? { width: '99%', display: 'none' }: { width: '99%' }}>
                <p className={`text-lg font-semibold text-black justify-end inline-flex mr-[5px] ${AccountOption === "multi"?LegerEndpoint === "payment"?'w-[89%]':LegerEndpoint === "journal"?AccountType === "Destination"?"w-[84%]":"w-[88%]":'w-[84%]':'w-[96%]'}`}>
                    <span className={`justify-end inline-flex mr-[10px] ${AccountType === "Destination" ? LegerEndpoint === "journal"?"w-[66%]":"w-[60%]" : LegerEndpoint === "receipt"?"w-[52%]":"w-[45%]"}`}>{AccountOption === "multi" && "Total"} {AccountType} Amount</span>
                    <span className={`${AccountType === "Destination" ? LegerEndpoint === "payment"?"min-w-[23%]":LegerEndpoint === "journal"?"min-w-[31%]":"min-w-[36%]" : LegerEndpoint === "receipt"?"min-w-[36%]":LegerEndpoint === "journal"?"min-w-[28%]":LegerEndpoint === "contra"?"min-w-[35%]":"min-w-[37%]"} justify-end inline-flex`}>{AccountOption === "multi" ? isNaN(getAmount().toFixed(2)) ? "0.00" : getAmount().toFixed(2) : isNaN(parseFloat(singleAccountNumber).toFixed(2)) ? "0.00" : parseFloat(singleAccountNumber).toFixed(2)}</span>
                </p>
            </div>
        </div>
            
    )
}
